import { useQuery } from "@tanstack/react-query";
import api from "../../utils/api";
import { jwtDecode } from "jwt-decode";

/**
 * 서버 GET /user/info 호출
 * 서버에서 Hybris SSO 인증 검증 + customers 조회 후 JWT로 반환
 * FE에서는 JWT 디코딩하여 customers 데이터 추출
 */
const fetchUserInfo = () => {
    return api("/user/info").then((response) => {
        const { token } = response.data.data;
        // JWT 디코딩하여 customers 추출 (서명 검증은 서버에서 완료)
        const decoded = jwtDecode(token);
        return decoded.customers;
    });
};

export const useUserInfoQuery = () => {
    return useQuery({
        retry: 1,
        queryKey: ["getUserInfo"],
        queryFn: fetchUserInfo,
    });
};
